import React from "react";
import { observer } from "mobx-react";

import { SportOffer } from "@gp/offer";

import { getSportOfferKey } from "@utils/offer";

import { PrematchSport } from "./PrematchSport";

export const PrematchSportsList = observer(function PrematchSportsList(props: {
	sports: SportOffer[];
}) {
	return (
		<>
			{props.sports
				.sort((a, b) => (a.isLive === b.isLive ? 0 : a.isLive ? -1 : 1))
				.map((sport) => (
					<PrematchSport
						key={getSportOfferKey(sport)}
						sport={sport}
					/>
				))}
		</>
	);
});
